import {
    FontAwesomeIcon,
    FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import { useTheme } from "@mui/material/styles";

export const ActionIcon = (props: FontAwesomeIconProps) => {
    const theme = useTheme();

    return (
        <FontAwesomeIcon
            {...props}
            style={{
                color: theme.palette.grey[600],
                fontSize: "22px",
                ...props.style,
            }}
        />
    );
};
